import { z } from 'zod';
import axios from 'axios';

export const ReferralSourceSchema = z.object({
  id: z.number(),
  name: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});
